import { Box } from "@mui/material"
import { SimpleLocationQueryAutocomplete } from "../hints/LocationAutocomplete"
import OotItemContextMenuButton from "../hints/OotItemContextMenuButton"


export const WothHint = () => {

    return <Box display="flex">
        <SimpleLocationQueryAutocomplete sx={{backgroundColor: "blue", width: 200, height: 40}} />
        <OotItemContextMenuButton /><OotItemContextMenuButton /><OotItemContextMenuButton /><OotItemContextMenuButton />
    </Box>
}

export const BarrenHint = () => {

    return <>
        <SimpleLocationQueryAutocomplete sx={{backgroundColor: "red",  width: 200, height: 40}} />
    </>
}